import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateUser, useUploadUserPhoto } from '../../../hooks/useUsers';
import { useToast } from '../../../hooks/useToast';
import UserForm from '../../../components/forms/UserForm';
import { ArrowLeft } from 'lucide-react';

const UserCreate = () => {
  const navigate = useNavigate();
  const createUser = useCreateUser();
  const uploadUserPhoto = useUploadUserPhoto();
  const toast = useToast();

  const handleSubmit = async (data) => {
    try {
      const { photoFile, ...userData } = data;
      const created = await createUser.mutateAsync(userData);

      if (photoFile) {
        try {
          await uploadUserPhoto.mutateAsync({ id: created.id, file: photoFile });
        } catch (uploadError) {
          toast.warning('Usuário criado, mas erro ao enviar foto: ' + uploadError.message);
          navigate('/admin/usuarios');
          return;
        }
      }

      toast.success('Usuário criado com sucesso!');
      navigate('/admin/usuarios');
    } catch (error) {
      toast.error('Erro ao criar usuário: ' + error.message);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={() => navigate('/admin/usuarios')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar para lista
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Novo Usuário</h1>
        <p className="text-gray-600 mt-1">
          Cadastre um novo usuário no sistema
        </p>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <UserForm
          onSubmit={handleSubmit}
          isLoading={createUser.isPending || uploadUserPhoto.isPending}
        />
      </div>
    </div>
  );
};

export default UserCreate;
